module.exports = __webpack_public_path__ + "static/media/defrag_4.37b3b77d.ico";